"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.effectNamesKey = Symbol('effectnames');
exports.typeDefNamesKey = Symbol('typenames');
exports.asyncTypeDefNamesKey = Symbol('asynctypenames');
//# sourceMappingURL=metadataKeys.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@awaw00/rxstore/lib/metadataKeys.js
// module id = 109
// module chunks = 0